import { render, staticRenderFns } from "./InspectDepartModal.vue?vue&type=template&id=0ef26280&"
import script from "./InspectDepartModal.vue?vue&type=script&lang=js&"
export * from "./InspectDepartModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ef26280')) {
      api.createRecord('0ef26280', component.options)
    } else {
      api.reload('0ef26280', component.options)
    }
    module.hot.accept("./InspectDepartModal.vue?vue&type=template&id=0ef26280&", function () {
      api.rerender('0ef26280', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prevent/basedata/modules/InspectDepartModal.vue"
export default component.exports